import {useReviewsAnalysisFilter} from '../../../reviews-analysis-hook';
import {ReviewsCompareEnum} from '../../../reviews-analysis-type';

type PropsType = {
    renderSingle: JSX.Element | null;
    renderPeriod: JSX.Element | null;
    renderCompetitor: JSX.Element | null;
};

export function CompareModeResolver(props: PropsType): JSX.Element | null {
    const {renderSingle, renderPeriod, renderCompetitor} = props;

    const {compareMode} = useReviewsAnalysisFilter();

    switch (compareMode) {
        case ReviewsCompareEnum.PERIOD:
            return renderPeriod;
        case ReviewsCompareEnum.COMPETITOR:
            return renderCompetitor;
        default:
            return renderSingle;
    }
}
